import React from "react";
//#region redux
import { AppState } from "store";
import { useDispatch, useSelector } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
import { loadItems, setCurrentIndex } from "store/actions/listActions";
//#endregion
//#region types
//#endregion
//#region components
import useMountedState from "../useMountedState";
import useTableEntityNavigation from "./useTableEntityNavigation";
import EntityPagination from "../drawers/entityView/entityPagination";
//#endregion

const TableItemNavigation: React.FC = (props) => {
  const { getMounted } = useMountedState();

  const dispatch: ThunkDispatch<any, any, any> = useDispatch();
  const { total, loadNext, indexToOpen, pageToOpen, numPerPage, navigationIds, itemUrl } = useSelector(
    (store: AppState) => store.list
  );

  const [loading, setLoading] = React.useState(false);
  const [nextPageItems, setNextPageItems] = React.useState<{
    page: number;
    items: (string | number)[];
    total: number;
  }>();

  const { goToItem, isTableEntityNavigation } = useTableEntityNavigation();

  const navigateToEntity = (id: number | string, index: number, page: number) => {
    if (itemUrl) {
      dispatch(setCurrentIndex(index, page));
      goToItem(id, itemUrl!, true);
    }
  };

  const updateCurrent = (index: number, page: number) => {
    if (navigationIds !== undefined) {
      if (pageToOpen !== page || navigationIds[index] === undefined) {
        reloadItems(index, page);
      } else {
        navigateToEntity(navigationIds![index], index, page);
      }
    }
  };

  const reloadItems = (index: number, page: number) => {
    if (nextPageItems?.page === page) {
      dispatch(loadItems(nextPageItems.items, nextPageItems.total));
      navigateToEntity(nextPageItems.items[index], index, page);
    } else if (loadNext) {
      setLoading(true);
      loadNext(page).then((results) => {
        if (getMounted()) {
          const items = results.items ?? [];
          dispatch(loadItems(items, results.total));
          navigateToEntity(items[index], index, page);
          setLoading(false);
        }
      });
    }
  };

  const onBeforePageEnd = (nextPage: number) => {
    if (loadNext) {
      setLoading(true);
      loadNext(nextPage).then((results) => {
        if (getMounted()) {
          setNextPageItems({ ...results, page: nextPage });
          setLoading(false);
        }
      });
    }
  };

  const enableNavigation = () => {
    return indexToOpen !== undefined && navigationIds && isTableEntityNavigation();
  };

  return enableNavigation() ? (
    <EntityPagination
      total={total}
      onCurrentIndexUpdate={updateCurrent}
      initialIndex={indexToOpen ?? 0}
      navigationText={""}
      initialPage={pageToOpen}
      numPerPage={numPerPage}
      loadingNext={loading}
      onBeforePageEnd={onBeforePageEnd}
    />
  ) : (
    <></>
  );
};

export default TableItemNavigation;
